import { render, staticRenderFns } from "./PriceLine.vue?vue&type=template&id=6edf32c8&scoped=true&"
import script from "./PriceLine.vue?vue&type=script&lang=js&"
export * from "./PriceLine.vue?vue&type=script&lang=js&"
import style0 from "./PriceLine.vue?vue&type=style&index=0&id=6edf32c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf32c8",
  null
  
)

/* custom blocks */
import block0 from "./PriceLine.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports